import { connect } from 'react-redux';
import { appOperations } from '../../../../../../App/store';
import { ListItem, TextField, ListItemText } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../../store';
import { previewHistoryBatch } from '../../../store/extensions';
import ColoredSnackbarConstants from '../../../../../misc/ColoredSnackbar/ColoredSnackbarConstants';

const styles = theme => ({
    input: {
        fontSize: 14,
        fontWeight: 500
    }
});

function removeZWJEmojis(input) {
  return input.replace(/\p{Emoji}(?:\u200D\p{Emoji})+/gu, '');
}

const TextFieldListItem = (props) => {
    const { classes, textElementValue, openSnack, index, updateTextElement, ...other } = props;

    const removeInvalidSymbols = (text) => {
        return removeZWJEmojis(text);
    }
    
    const onTextChange = (event) => {
        const maxLength = 100;
        
        if (event.target.value.length <= maxLength - 1) 
            updateTextElement(index, { text: removeInvalidSymbols(event.target.value) });
        else 
            openSnack(`Text should not be longer than ${maxLength} characters.`, ColoredSnackbarConstants.SNACKBAR_WARNING);
    }
    
    return (
        <ListItem {...other}>
            <ListItemText>
                <TextField
                    variant="standard"
                    value={removeInvalidSymbols(textElementValue)}
                    label={`Text ${index + 1}`}
                    fullWidth
                    onChange={onTextChange}
                    InputProps={{
                        classes: {
                            input: classes.input
                        }
                    }}
                    onFocus={() => previewHistoryBatch.start()}
                    onBlur={() => previewHistoryBatch.end()}
                />
            </ListItemText>
        </ListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const { text: textElementValue } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    return { textElementValue };
}

const mapDispatchToProps = (dispatch) => {
    const openSnack = (text, variant) => dispatch(appOperations.openSnack(text, variant));
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return {
        openSnack, 
        updateTextElement
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TextFieldListItem, styles));